import React from 'react';

import { useGetPostQuery } from '../../../../graphql/gen/types';
import { Loader } from '../../../shared/Loader';
import { SyncPostFromGoogleDocs } from './SyncPostFromGoogleDocs';

type Props = {
  postId: string;
};

export const SyncPostFromGoogleDocsDialog = ({ postId }: Props): React.ReactElement => {
  const { data } = useGetPostQuery({ variables: { postId } });

  if (data?.loggedIn?.postById != null) {
    return <SyncPostFromGoogleDocs post={data.loggedIn.postById} />;
  }

  return <Loader size={24} />;
};
